import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SampleConsentDoc } from "../demo/SampleConsentDoc";
import { DEMO_THERAPIST } from "../demo/mock-data";

/**
 * Sample agreements view (Scope A9 — "informed-consent + BAA-style forms as
 * read-only sample templates"). Surfaces the therapist-facing BAA + HIPAA
 * acknowledgment (reused real FORM_CONTENT), so the BAA handling is reachable, not
 * just per-client consent. All watermarked SAMPLE; nothing is signed or stored.
 */
export function DemoAgreements() {
  return (
    <main className="mx-auto max-w-3xl px-4 py-8">
      <div className="flex items-center justify-between">
        <h1 className="font-heading text-3xl font-medium text-[var(--color-text-primary)]">Your agreements</h1>
        <Link to="/dashboard" className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-wide text-[var(--color-text-ghost)] transition-colors hover:text-[var(--color-gold-soft)]">
          <ArrowLeft className="h-3 w-3" /> Dashboard
        </Link>
      </div>
      <p className="mt-1 text-[14px] leading-relaxed text-[var(--color-text-muted)]">
        At sign-up you sign a HIPAA Business Associate Agreement and a compliance acknowledgment — even on the free
        tier. These are the real Psy180 templates, shown here as read-only samples.
      </p>

      <div className="mt-6 space-y-3">
        <SampleConsentDoc formType="platform_baa" states={["WA", "UT"]} clinicName={DEMO_THERAPIST.clinic} defaultOpen />
        <SampleConsentDoc formType="hipaa_acknowledgment" states={["WA", "UT"]} clinicName={DEMO_THERAPIST.clinic} />
        <SampleConsentDoc formType="npp" states={["HIPAA"]} clinicName={DEMO_THERAPIST.clinic} />
      </div>
    </main>
  );
}
